/* eslint-disable react-hooks/exhaustive-deps */
// // eslint-disable-next-line no-unused-vars

// export default Navbar;
import { useState } from "react";
import { Slide } from "react-awesome-reveal";
import { IoSearch } from "react-icons/io5";
import { useRef, useEffect } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { navItems } from "./navbarList";
import { LoginItems } from "./navbarList";
// import { GetStarted } from "../GetStarted";
import { motion, } from "framer-motion";
import ercLogo from "../../assets/images/brandImg/erc-logo.png";
// import { Marquee } from "../marquee/Marquee";

// type NavItem = {
//   label: string;
//   link?: string;
//   children?: NavItem[];
//   iconImage?: string;
// };

 const Navbar = () => {
  const [animationParent] = useAutoAnimate();

  const [isSideMenuOpen, setSideMenue] = useState(false);
  const parent = useRef(null);
  const [navColor, setNavColor] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 700) {
      setNavColor(true);
    } else {
      setNavColor(false);
    }
  };

  window.addEventListener("scroll", handleScroll);

  useEffect(() => {
    parent.current && animationParent(parent.current);
  }, [parent]);

  function openSideMenu() {
    setSideMenue(true);
  }
  function closeSideMenu() {
    setSideMenue(false);
  }
  const variants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  return (
    <div className="w-full">
      {/* <Marquee /> */}
      <div
        className= "flex   bg-[#fff] transition-all ease-in w-full shadow-lg md:px-12 px-6 justify-between items-center py-6 text-sm"
      >
        {/* left side */}
        <section>
          {/* logo */}
          <Link to="/" className="max-w-28  ">
          
              <img              src={ercLogo}  alt="logo" className="h-12" />
     
          </Link>
        </section>
        {/* middle side  */}
        <section ref={animationParent} className="flex items-center gap-10">
          {isSideMenuOpen && (
            <MobileNav closeSideMenu={closeSideMenu}  />
          )}
          <div className="hidden lg:flex items-center gap-4 transition-all">
            {navItems.map((d, i) => (
              <div
                key={i}
                className="relative group  px-2 py-3 transition-all "
              >
                <p
                  className={
                    navColor
                      ? "flex cursor-pointer items-center gap-2 text-[#fff] font-medium  text-[18px]  "
                      : "flex cursor-pointer items-center gap-2 text-primaryColor font-medium  text-[18px] "
                  }
                >
                  <a href={d.link ?? "#"}>{d.label}</a>
                  {d.children && (
                    <IoMdArrowDropdown className=" text-[28px] rotate-180  transition-all group-hover:rotate-0" />
                  )}
                </p>

                {/* dropdown */}
                {d.children && (
                  <motion.div
                    initial="hidden"
                    animate="visible"
                    variants={variants}
                    className="absolute   right-0   top-10 hidden w-auto  flex-col gap-1   rounded-lg bg-white py-3 shadow-md  transition-all group-hover:flex "
                  >
                    {d.children.map((ch, i) => (
                      <div key={i}>
                        <a
                          href={ch.link ?? "#"}
                          className=" flex cursor-pointer items-center  py-1 pl-6 pr-8  text-primaryColor font-medium hover:text-secondary  "
                        >
                          {/* item */}
                          <span className="whitespace-nowrap   pl-3 ">
                            {ch.label}
                          </span>
                        </a>
                        {i !== d.children.length - 1 && (
                          <hr className="my-2 border-t border-gray-200" />
                        )}
                      </div>
                    ))}
                  </motion.div>
                )}
              </div>
            ))}

            {/* sub dropdown */}
          </div>
          {/* navitems */}
        </section>
        {/* right side data */}
        <section className=" hidden lg:flex   items-center gap-8 ">
            <div className="relative">
         <input
           className="bg-[#FAFAFA] text-[#080808] text-[13px] font-semibold rounded-full py-2 px-4 w-[210px] border-none focus:outline-none focus:border-blue-500"
          placeholder="Search Anything"
       />
      <i className="absolute right-4 top-2 text-gray-500">         <IoSearch size={27} />
         </i>
       </div>
          <button
            ref={animationParent}
            className="h-fit text-primaryColor font-medium transition-all hover:text-black/90"
          >
            <div className="hidden md:flex items-center px-2 rounded-md text-primary bg-secondary gap-4 transition-all">
              {LoginItems.map((d, i) => (
                <div
                  key={i}
                  // to={d.link ?? "#"}
                  className="relative group  px-2 py-3 transition-all "
                >
                  <p
                    className={
                      navColor
                        ? "flex cursor-pointer items-center gap-2 text-[#fff] font-medium  text-[18px] group-hover:text-black "
                        : "flex cursor-pointer items-center gap-2 text-primaryColor font-medium  text-[18px] "
                    }
                  >
                    <span>{d.label}</span>
                    {d.children && (
                  <IoMdArrowDropdown className=" text-[28px] rotate-180  transition-all group-hover:rotate-0" />
                    )}
                  </p>

                  {/* dropdown */}
                  {d.children && (
                    <div className="absolute   right-0 text-black   top-10 hidden w-auto  flex-col gap-1   rounded-lg bg-white py-3 shadow-md  transition-all group-hover:flex ">
                      {d.children.map((ch, i) => (
                        <div key={i}>
                          <a
                            href={ch.link ?? "#"}
                            className=" flex cursor-pointer items-center  py-1 pl-6 pr-8  text-primaryColor hover:text-secondary  "
                          >
                            {/* item */}
                            <span className="whitespace-nowrap   pl-3 ">
                              {ch.label}
                            </span>
                          </a>
                          {i !== d.children.length - 1 && (
                            <hr className="my-2 border-t border-gray-200" />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}

              {/* sub dropdown */}
            </div>
          </button>
        </section>
        {navColor ? (
          <FiMenu
            onClick={openSideMenu}
            className="cursor-pointer text-white text-4xl lg:hidden"
          />
        ) : (
          <FiMenu
            onClick={openSideMenu}
            className="cursor-pointer text-[#13162D]  text-4xl lg:hidden"
          />
        )}
      </div>
    </div>
  );
};

function MobileNav({ closeSideMenu, isSideMenuOpen, showDrops }) {
  return (
    <div className="fixed right-0 top-0 text-[#13162D]   h-screen z-[9999]   md:w-[400px] w-full  bg-white lg:hidden">
      <Slide
        direction="right"
      // keyframes={isSideMenuOpen ? "slideRightAndBack" : "slideBackLeft"}
      >
        <div className="  w-full   px-4 py-4">
          <section className="flex justify-between pt-12">
          <section>
          {/* logo */}
          <Link to="/" className="max-w-28  ">
          
              <img              src={ercLogo}  alt="logo" className="h-12" />
     
          </Link>
        </section>
            <AiOutlineClose
              onClick={closeSideMenu}
              className="cursor-pointer text-black text-4xl "
            />
          </section>
          <div className=" flex flex-col text-xl font-bold pt-12 text-[#13162D]  gap-2 transition-all">
            {navItems.map((d, i) => (
              <SingleNavItem key={i} label={d.label} link={d.link}>
                {d.children}
              </SingleNavItem>
            ))}
          </div>

          <section className="  flex  flex-row   gap-4  mt-4 items-center">
            {/* <button
              onClick={showDrops}
              className="h-fit rounded-full font-Gotic px-[48px] py-[14px] bg-[#e2e5f3] text-[#13162D] hover:bg-[#FDBF17] hover:text-[#13162D] border-2 border-[#FDBF17] transition-all hover:border-0 "
            >
              Get Started
            </button> */}
            <button className="h-fit text-primary bg-secondary font-bold text-xl transition-all">
              {LoginItems.map((d, i) => (
                <SingleNavItem key={i} label={d.label} link={d.link}>
                  {d.children}
                </SingleNavItem>
              ))}
            </button>
          </section>
        </div>
      </Slide>
    </div>
  );
}

function SingleNavItem(d) {
  const [animationParent] = useAutoAnimate();
  const [isItemOpen, setItem] = useState(false);

  function toggleItem() {
    return setItem(!isItemOpen);
  }

  return (
    <div
      ref={animationParent}
      onClick={toggleItem}
      // href={d.link ?? "#"}
      // target="_blank"
      className="relative   px-2 py-3 transition-all "
    >
      <p className="flex cursor-pointer items-center font-medium gap-2 text-[#13162D]  group-hover:text-black ">
        <span>{d.label}</span>
        {d.children && (
          // rotate-180
          <IoMdArrowDropdown
            className={` transition-all text-[28px]   ${isItemOpen && " rotate-180"}`}
          />
      
        )}
      </p>

      {/* dropdown */}
      {isItemOpen && d.children && (
        <div className="  w-auto  flex-col gap-1   rounded-lg bg-white py-3   transition-all flex ">
          {d.children.map((ch, i) => (
            <div key={i}>
              <a
                href={ch.link ?? "#"}
                className=" flex cursor-pointer items-center  py-1 pl-6 pr-8  text-[#13162D]  hover:text-black  "
              >
                <span className="whitespace-nowrap   pl-3 ">{ch.label}</span>
              </a>
              {i !== d.children.length - 1 && (
                <hr className="my-2 border-t border-gray-200" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
export default Navbar
